// extracted by mini-css-extract-plugin
module.exports = {"historyContainer":"History_historyContainer__2Hh0T"};